<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'资讯管理'},{name:'资讯列表'}]" :title="'资讯列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">上架状态</span>
                        <el-select v-model="sendInfo.status" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">发布日期</span>
                       <el-date-picker
                        size="small"
						v-model="sendInfoOne.time"
                        format="yyyy-MM-dd"
						value-format="yyyy-MM-dd HH:mm:ss"
						type="datetimerange"
						:default-time="['24:00:00','23:59:59']"
					    range-separator="至"
					    start-placeholder="开始日期"
					    end-placeholder="结束日期">
                       </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                    <el-button type="primary" size="small" icon="el-icon-plus"
                               v-if="authorities.indexOf('sys:permission:background:information:list:button:release')!=-1" @click="edit()">发布资讯</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                :default-sort="{prop: 'date'}"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="资讯ID">
                </el-table-column>
                <el-table-column
                    prop="title"
                    show-overflow-tooltip
                    
                    width="400"
                    label="资讯标题">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    
                    label="上架状态">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    label="更新账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="更新时间">
                </el-table-column>
                <el-table-column prop="views" sortable="custom" show-overflow-tooltip  label="浏览数" width="100"></el-table-column>

                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:information:list:button:view')!=-1 ||
                    authorities.indexOf('sys:permission:background:information:list:button:edit')!=-1 ||
                    authorities.indexOf('sys:permission:background:information:list:button:status')!=-1"
                    label="操作"
                    
                    width="300">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="check(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:information:list:button:view')!=-1">查看</el-button>
                        <el-button :class="{'noclick':scope.row.isEditable==1||scope.row.status==1}"  size="small" type="primary" class="super" plain @click="edit(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:information:list:button:edit')!=-1">编辑</el-button>
                        <el-button :class="{'noclick':scope.row.isEditable==1}" size="small" type="primary" class="super" plain @click="soldOut(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:information:list:button:status')!=-1">{{scope.row.btnValue}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <Paging
                :PageData="PageData"
                @nextpage="nextpage"
                @previouspage="previouspage"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                ></Paging>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
			      statusList:[],//上下架
            options: [{
                value: '2',
                label: '资讯标题'
                }, {
                value: '3',
                label: '发布账号'
            },{
                value: '4',
                label: '更新账号'
            }],//检索下拉
            sendInfoOne:{
                usls:"",//上架状态
                time:"",//发布日期
                drop:'',//检索选择值
                dropValue:'',//检索输入值
            },//检索提交数据
			sendInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				endDate:null,//结束时间
				startDate:null,//开始时间
				id:null,//资讯ID
				status:null,//上架状态
				title:null,//咨询标题
				updateUserName:null,//更新账号
				incubatorName:null,//孵化器名称
				name:null,//姓名
				userName:null,//账号
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
			dataInfo:'',//详细信息
            tableData:[],//表格数据
        }
    },
	created() {
		getDict('UA_LS').then(data=>{
		    this.statusList = data.UA_LS;
		})
		this.getList();
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      onReset(){
        const params = {
          currentPage:1,//当前页
				pageSize:10,//页条数
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				endDate:null,//结束时间
				startDate:null,//开始时间
				id:null,//资讯ID
				status:null,//上架状态
				title:null,//咨询标题
				updateUserName:null,//更新账号
				incubatorName:null,//孵化器名称
				name:null,//姓名
				userName:null,//账号
        }
        this.sendInfo = Object.assign(this.sendInfo,params)
        const aa = {
          usls:"",//上架状态
                time:"",//发布日期
                drop:'',//检索选择值
                dropValue:'',//检索输入值
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,aa)
        if(this.$refs.table) this.$refs.table.clearSort()
        this.retrieval()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		//
		getList(){
      this.loading = true
			this.$axiosc.get('/backstage/news/all/list',{params:this.sendInfo}).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //查询
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0]
				this.sendInfo.endDate=lookData.time[1]
			}else{
				this.sendInfo.startDate=null
				this.sendInfo.endDate=null
			}
			// 检索值
			let lookdell=lookData.drop;
			if(lookdell==1){
				this.sendInfo.id=lookData.dropValue;
				this.sendInfo.userName=null;
				this.sendInfo.updateUserName=null;
				this.sendInfo.title=null;
			}else if(lookdell==2){
				this.sendInfo.title=lookData.dropValue;
				this.sendInfo.id=null;
				this.sendInfo.updateUserName=null;
				this.sendInfo.userName=null;
			}else if(lookdell==3){
				this.sendInfo.userName=lookData.dropValue;
				this.sendInfo.title=null;
				this.sendInfo.id=null;
				this.sendInfo.updateUserName=null;
			}else if(lookdell==4){
				this.sendInfo.updateUserName=lookData.dropValue;
				this.sendInfo.title=null;
				this.sendInfo.id=null;
				this.sendInfo.userName=null;
			}
			this.getList()
		},
        //表格排序
        sortChange:function({ column, prop, order }){

           if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfo.property=prop;
            this.sendInfo.direction=order;
            this.getList()
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:'/messageManagement/detail',query:{id:row.id,index:'/messageManagement'}})
        },
        //发布 编辑
        edit:function(row){
            if(row){//编辑
              if(row.isEditable==1 || row.status==1){
                return
              }
                this.$router.push({path:'/messageManagement/edit',query:{id:row.id,index:'/messageManagement'}})
            }else{//发布
                this.$router.push({path:'/messageManagement/add',query:{index:'/messageManagement'}})
            }
        },
        //表格下架,上架按钮
        soldOut:function(row){
			if(row.isEditable==1) {
                return
            }
            let btnValue=row.btnValue;

            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
        			this.$axiosc.put('backstage/news/shelf/obtained/'+row.id).then((r)=>{
        			    if(r.code==200){
        			        this.$message({
        			            type: 'success',
        			            message: btnValue+'成功!'
        			        });
        			        this.getList();
        			    }else{
        			        this.$alert(r.msg);
        			    }
        			})

                }).catch(() => {
            });
        },
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
          this.sendInfo.currentPage = val;
          this.getList()
        },
    },watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>
<style scoped="scoped">
	.noclick{
		color: #DDDDDD;
		border: 1px solid #ddd;
	}
</style>
